import { Slice, createSlice } from "@reduxjs/toolkit";
import { fetchSiteDetails } from "../thunk/MapSliceThunk";

const initialData: any = [];

const MapSiteDetailsSlice: Slice<any, {}, "MapSiteDetailsSlice"> = createSlice({
    name: "MapSiteDetailsSlice",
    initialState: { data: initialData, isLoading: false, error: "" },
    reducers: {},
    extraReducers(builder) {
        builder.addCase(fetchSiteDetails.pending, (state, action) => {
            state.isLoading = true
        });
        builder.addCase(fetchSiteDetails.fulfilled, (state, action) => {
            state.isLoading = false
            state.data = action.payload
        });
        builder.addCase(fetchSiteDetails.rejected, (state, action) => {
            state.isLoading = false
            state.error = action.error.message ?? ""
        });
    }
})

export default MapSiteDetailsSlice